<template>
  <div
    v-if="!registeredTrial && !bookingsLinkIsopen && showBookMeetingTip"
    class="book-meeting-container"
    :style="sidebarIsUnfold ? { left: 100 + 62 + 'px' } : { left: 62 + 'px' }"
  >
    <span class="arrow-left"></span>
    <div class="book-meeting-close">
      <svg-icon
        name="book-meeting-close"
        @click.native="closeBookMeetingTip"
      ></svg-icon>
    </div>
    <div class="title">Schedule a meeting</div>
    <div class="des">
      Book a virtually meeting with us anytime
    </div>
    <div class="btn-container">
      <div class="btn" @click="closeBookMeetingTip">OK</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import appendToDom from "@/components-v3/mixins/append-to-dom";
import { userPermissionsConfig$ } from "@/shared-services";
import { map } from "rxjs";
export default {
  name: "bookMeeting",
  mixins: [appendToDom(document.getElementById("side-bar"))],
  components: {},
  data() {
    return {
      showBookMeetingTip: false,
      bookingsLinkIsopen: false,
    };
  },

  computed: {
    ...mapState({
      sidebarIsUnfold: (state) => state.user.sidebarIsUnfold,
      registeredTrial: (state) => state.user.sidebarIsUnfold,
      userId: (state) => state.user.userId,
    }),
  },
  mounted() {
    let self = this;
    self.bookingsLinkIsopen =
      localStorage.getItem(`bookingsLinkIsopen${this.userId}`) === "true";
    userPermissionsConfig$
      .pipe(
        map((x) => {
          x.$bookMeeting.subscribe((x) => {
            if (x) {
              self.showBookMeetingTip = true;
            }
          });
        })
      )
      .subscribe();
  },
  watch: {},
  methods: {
    closeBookMeetingTip() {
      this.showBookMeetingTip = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.book-meeting-container {
  display: flex;
  padding: 20px 24px 24px;
  width: 322px;
  height: 142px;
  background: #395bbe;
  border-radius: 6px;
  flex-direction: column;
  position: relative;
  position: absolute;
  z-index: 111;
  left: 62px;
  bottom: 54px;
  .book-meeting-close {
    position: absolute;
    top: 12px;
    right: 12px;
    svg {
      font-size: 16px;
      cursor: pointer;
    }
  }
  .title {
    font-family: "Open Sans";
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    line-height: 24px;
  }
  .des {
    font-family: "Open Sans";
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    margin-top: 4px;
    line-height: 22px;
  }
  .arrow-left {
    width: 0;
    height: 0;
    border-top: 11px solid transparent;
    border-right: 10px solid #395bbe;
    border-bottom: 11px solid transparent;
    font-size: 0;
    line-height: 0;
    position: absolute;
    left: -10px;
    bottom: 24px;
  }
  .btn-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    .btn {
      width: 80px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Open Sans";
      font-weight: 700;
      font-size: 12px;
      color: #4066d4;
      cursor: pointer;
    }
  }
}
</style>
